import React from 'react';
import { AppButton, AppCheckbox } from '@/components/atoms';

interface Props {
  outputOption1: boolean;
  onOutputOption1Change: (checked: boolean) => void;
  onExportCsv: () => void;
  isExporting: boolean;
}

const MassagerCsvFooter: React.FC<Props> = ({
  outputOption1,
  onOutputOption1Change,
  onExportCsv,
  isExporting,
}) => {
  return (
    <div className="flex items-center w-full gap-6 px-4">
      <AppCheckbox checked={outputOption1} onChange={e => onOutputOption1Change(e.target.checked)}>
        <span className="text-white whitespace-nowrap">施術報告料印刷</span>
      </AppCheckbox>

      <AppButton
        type="primary"
        className="px-6 rounded whitespace-nowrap"
        loading={isExporting}
        onClick={onExportCsv}
      >
        CSVデータ出力
      </AppButton>

      <span className="text-sm text-white">
        施術者毎CSVは現時点の集計結果です。申請書金額と異なる場合があります。
      </span>
    </div>
  );
};

export default MassagerCsvFooter;
